import { render, staticRenderFns } from "./AddRoomCost.vue?vue&type=template&id=5cba9d89&scoped=true&"
import script from "./AddRoomCost.vue?vue&type=script&lang=js&"
export * from "./AddRoomCost.vue?vue&type=script&lang=js&"
import style0 from "./AddRoomCost.vue?vue&type=style&index=0&id=5cba9d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba9d89",
  null
  
)

export default component.exports